'use client'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/ui/select'
import { CONTACT_FREQUENCY_OPTIONS } from './meta'
import type { ContactFrequency } from './meta'

interface ContactFrequencySelectorProps {
  value: string | null
  onChange: (value: ContactFrequency | null) => void
}

/**
 * Compact frequency selector for the person detail panel.
 * Allows setting how often you want to stay in touch.
 */
export function ContactFrequencySelector({
  value,
  onChange,
}: ContactFrequencySelectorProps) {
  return (
    <Select
      value={value ?? '__none__'}
      onValueChange={(v) => {
        onChange(v === '__none__' ? null : (v as ContactFrequency))
      }}
    >
      <SelectTrigger
        size="sm"
        aria-label="Contact frequency"
        className="h-8 w-auto min-w-[120px] text-xs sm:h-7"
      >
        <SelectValue placeholder="Frequency" />
      </SelectTrigger>
      <SelectContent position="popper" align="start">
        {CONTACT_FREQUENCY_OPTIONS.map((opt) => (
          <SelectItem key={opt.value} value={opt.value}>
            {opt.label}
          </SelectItem>
        ))}
        <SelectSeparator />
        <SelectItem value="__none__">None</SelectItem>
      </SelectContent>
    </Select>
  )
}
